import React from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import AppIcon from '../../components/AppIcon';

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const GoodbyePage = ({ t }) => {
  return (
    <Wrapper>
      <h1>
        {t('GoodbyeHeader')}
      </h1>
      <AppIcon name='heart' style={{fontSize: '4rem', color: 'var(--br-danger)'}} aria-hidden='true' />
      <h2 style={{color: 'var(--br-muted)'}}>
        {t('GoodbyeMessage')}
      </h2>
      <span>
        {'Check out the '}
        <a href='https://betareader.io/blog'>
          Beta Blog
        </a>
      </span>
    </Wrapper>
  )
}

export default withTranslation()(withRouter(GoodbyePage));
